import { render, staticRenderFns } from "./detailsNew.vue?vue&type=template&id=abee4ab2&scoped=true&"
import script from "./detailsNew.vue?vue&type=script&lang=js&"
export * from "./detailsNew.vue?vue&type=script&lang=js&"
import style0 from "./detailsNew.vue?vue&type=style&index=0&id=abee4ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abee4ab2",
  null
  
)

component.options.__file = "detailsNew.vue"
export default component.exports